// Posiciona um painel flutuante a partir do elemento que o abriu.
//
// Existe porque painel `absolute` dentro do componente é recortado por
// QUALQUER ancestral com overflow-hidden — e todo cartão arredondado do
// produto tem um. z-index não resolve: overflow recorta o filho
// independentemente da camada. A saída é tirar o painel do fluxo (Teleport
// para o <body>, `position: fixed`) e posicioná-lo aqui.

const VIEWPORT_GAP = 8;

// Tamanho aproximado do quadro do seletor de cor (@lk77/vue3-color Chrome).
// Usado só no primeiro frame, antes de o painel existir no DOM para ser
// medido, para ele não abrir piscando no canto da tela.
export const CHROME_PANEL_SIZE = { width: 225, height: 240 };

/**
 * Calcula `left`/`top` em pixels para um painel `fixed`.
 *
 * Alinha o painel pela DIREITA da âncora (cresce para dentro da tela, que é
 * onde há espaço quando a âncora está encostada na borda) e o joga para cima
 * quando não couber embaixo. Sempre dentro da viewport.
 *
 * @param {Element} anchorEl elemento que abriu o painel
 * @param {Element} [panelEl] o painel já renderizado, para medir de verdade
 * @param {{width: number, height: number}} [fallback] tamanho estimado
 * @returns {{left: string, top: string}|{}} estilo pronto para :style
 */
export function anchoredPanelStyle(
  anchorEl,
  panelEl,
  fallback = CHROME_PANEL_SIZE
) {
  if (!anchorEl?.getBoundingClientRect) return {};

  const anchor = anchorEl.getBoundingClientRect();
  const panel = panelEl?.getBoundingClientRect?.();
  const width = panel?.width || fallback.width;
  const height = panel?.height || fallback.height;

  const maxLeft = window.innerWidth - width - VIEWPORT_GAP;
  const left = Math.max(VIEWPORT_GAP, Math.min(anchor.right - width, maxLeft));

  const below = anchor.bottom + VIEWPORT_GAP;
  const fitsBelow = below + height <= window.innerHeight;
  const top = fitsBelow
    ? below
    : Math.max(VIEWPORT_GAP, anchor.top - height - VIEWPORT_GAP);

  return { left: `${left}px`, top: `${top}px` };
}
